<template>
  <v-alert
    dense
    v-show="!loading"
    type="info"
    color="primary"
    @click="suggestNewContent"
    class="mt-5 mx-5 px-3 py-2 vetalfa-pointer"
    outlined
    style="background-color: white !important"
  >
    <p class="ma-0 pa-0 vetalfa-subtitle primary--text">
      Não encontrou um resultado esperado?
    </p>
    <p
      class="ma-0 pa-0 mt-1 vetalfa-subtitle primary--text"
      style="line-height: 14px"
    >
      <span class="text-decoration-underline">Clique aqui</span>
      para sugerir mudanças ou tirar dúvidas.
    </p>
  </v-alert>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "SearchNotFound",
  computed: {
    ...mapGetters("general", ["loading"]),
  },
  components: {},
  methods: {
    ...mapActions("general", ["logEvent", "contactUs"]),
    suggestNewContent() {
      this.logEvent("suggest_content_click");
      this.contactUs();
    },
  },
  data() {
    return {};
  },
};
</script>
